module.exports = __webpack_public_path__ + "media/waiting.747001be.mp3";